module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Compass-b9f1de619b6b819a18d2cc49bcda8c10.svg";